import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import connect from 'redux-connect-decorator';
import { getWordsByTopic } from '../../../../actions/glossaryActions';
import { Blob } from 'react-blob';

@connect(
  state => ({
    words: state.word.words,
    loading: state.word.loading
  }),
  {
    getWordsByTopic
  }
)
class Legal extends Component<any, any> {
  interval;

  constructor(props) {
    super(props);
    this.interval = 0;
    this.state = {
      random: 0,
      english: '...Loading',
      vietnamese: null,
      usage: null,
      pronunciation: null
    }
  }

  componentDidMount() {
    this.props.getWordsByTopic('Legal');
    this.interval = setInterval(() => this.setState({
      random: Math.floor(Math.random()*this.props.words.length),
      english: this.props.words[this.state.random].english,
      vietnamese: this.props.words[this.state.random].vietnamese,
      usage: this.props.words[this.state.random].usage,
      pronunciation: this.props.words[this.state.random].pronunciation
    }), 9000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    // const { words, loading } = this.props;
    // const filterWords = (wordsArray, obj) => wordsArray.filter( word => Object.keys(word).some( key => obj[key] && obj[key] === word[key]));
    // this.legal_words = filterWords(words,{topic:"Legal"});

    return (
      <>
        <SimpleHeader name="Legal" parentName="Glossary" />
        <Container className="mt--6" fluid>
          <Row>
          <div className="col">
                <Card>
                  <CardBody>
                    <div className="pt-1 text-center">
                      <Blob size="40vh"
                      style={{
                          position: 'relative',
                          // top: '-15%',
                          // right: '-15%',
                          zIndex: 999,
                          backgroundColor: '#daf0f5',
                          color: 'white',
                          // opacity: 0.15,
                          fontSize: '50vh',
                          margin: '0 auto 0 auto'
                        }}
                      >
                        <h1>{this.state.english}</h1>
                      </Blob>
                      <h2>{this.state.vietnamese}</h2>
                      <blockquote>
                        <p>
                          {this.state.usage}
                        </p>
                        <small>{this.state.pronunciation}</small>
                      </blockquote>
                    </div>
                  </CardBody>
                </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default Legal;
